export function bootstrap (data) {
  return {
    type: 'BOOTSTRAP_HIGHLIGHTS',
    data
  }
}
